import EducationCategoryForm from './EducationCategoryForm';
import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';
let header = {
  title: 'Add Education Category',
  actions: [cancelButton(), save()],
};

export default EducationCategoryForm({header});
